import { BreadcrumbItem } from 'store/breadcrumb/breadcrumbItem';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { ICS2ArrivalView } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';

/**
 * The trail to the arrival notifications, labelled as the other EU customs dashboards are.
 *
 * Only the dashboard has a page of its own to link to. The breadcrumb joins the non-empty paths and
 * renders them from the root layout, so this path is effectively absolute.
 */
export const arrivalDashboardBreadcrumbs: BreadcrumbItem[] = [
    { breadcrumbName: 'Customs Declarations', path: '' },
    { breadcrumbName: 'EU Customs', path: '' },
    {
        breadcrumbName: 'Arrival Notifications (ICS2)',
        path: `customs-declarations/${DeclarationCountry.EU}/${DeclarationInternalType.ARRIVAL_NOTIFICATION_ICS2}`,
    },
];

/** The arrival is named by the MRN customs gave it, and by its LRN until then. */
export const arrivalBreadcrumbs = (arrival?: ICS2ArrivalView): BreadcrumbItem[] => [
    ...arrivalDashboardBreadcrumbs,
    { breadcrumbName: arrival?.arrivalMrn || arrival?.lrn || 'Arrival Notification', path: '' },
];
